import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import CheckboxStatusUser from "components/Common/CheckboxStatusUser";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownChannelUser from "components/Common/DropdownChannelUser";
import DropdownCountries from "components/Common/DropdownCountries";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import DropdownPlatform from "components/Common/DropdownPlatform";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_STATUS_POST,
  COLOR_USER_ACCOUNT_TYPE,
  COLOR_USER_TYPE,
  LIST_CHANNEL_USER_OPTION,
  LIST_OPTION_GENDER,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  LIST_OPTION_USER_ACCOUNT_TYPE,
  LIST_OPTION_USER_TYPE,
  STATUS_POST_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatISOString, getPlatFormImage } from "helpers/format";
import CountUp from "react-countup";
import { deleteUser, getUsers as onGetUsers } from "store/user/thunk";
import UserDetail from "./Detail";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import { capitalizeFirstLetter, truncate } from "utils";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import noUser from "../../assets/images/no-user.png";
import countries from "helpers/countries";
import userApi from "api/userApi";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import { toast, ToastContainer } from "react-toastify";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import { ROUTES } from "routes/allRoutes";
import { useRole } from "components/Hooks/UserHooks";
import { useNavigate } from 'react-router-dom';
import ModalConfirm from "components/Common/ModalConfirm";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";

interface Option {
  label: string;
  value: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const UserManagement = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    nickname: withDefault(StringParam, ""),
    profile_email: withDefault(StringParam, ""),
    user_email: withDefault(StringParam, ""),
    ip: withDefault(StringParam, ""),
    app_version: withDefault(StringParam, ""),
    device_model: withDefault(StringParam, ""),
    udid: withDefault(StringParam, ""),
    address: withDefault(StringParam, ""),
    is_active: withDefault(StringParam, ""),
    platform: withDefault(StringParam, ""),
    os: withDefault(StringParam, ""),
    country: withDefault(StringParam, "KR"),
    channel: withDefault(StringParam, ""),
    login_type: withDefault(StringParam, ""),
    type: withDefault(StringParam, ""),
    registered_from: withDefault(StringParam, ""),
    registered_to: withDefault(StringParam, ""),
    include_deleted: withDefault(NumberParam, 0),
  });

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [addressSearch, setAddressSearch] = useState<string>(
    query?.address || ""
  );
  const [itemToEdit, setItemToEdit] = useState<any>(false);

  const STATUS_USER_OPTION_LANG =
    STATUS_POST_OPTION?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [nickNameSearch, setNicknameSearch] = useState<string>(
    query?.nickname || ""
  );
  const [emailSearch, setEmailSearch] = useState<string>(query?.profile_email || "");
  const [emailSNSSearch, setEmailSNSSearch] = useState<string>(query?.user_email || "");
  const [isDeletedUserSearch, setIsDeletedUserSearch] = useState<number>(
    query?.include_deleted || 0
  );

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.platform)
    )[0]
  );

  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.os)
    )[0]?.value || ""
  );

  const [ipAddressSearch, setIPAddressSearch] = useState<string>(
    query?.ip || ""
  );

  const [appVersionSearch, setAppVersionSearch] = useState<string>(
    query?.app_version || ""
  );

  const [deviceModelSearch, setDeviceModelSearch] = useState<string>(
    query?.device_model || ""
  );

  const [uuid2Search, setUUID2Search] = useState<string>(query?.udid || "");
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_POST_OPTION?.find(
      (item) => item?.value === parseInt(query?.is_active)
    )?.value ?? ""
  );

  const [userTypeSearch, setUserTypeSearch] = useState<any>(
    LIST_OPTION_USER_TYPE?.find(
      (item) => item?.value === (query?.login_type)
    )?.value ?? ""
  );

  const [accountTypeSearch, setAccountTypeSearch] = useState<any>(
    LIST_OPTION_USER_ACCOUNT_TYPE?.find(
      (item) => item?.value === (query?.type)
    )?.value ?? ""
  );

  const [channelSearch, setChannelSearch] = useState<Option | any>(
    LIST_CHANNEL_USER_OPTION?.find((item) => item?.value === query?.channel)
      ?.value || ""
  );

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.registered_from
      ? moment(query?.registered_from || "", "Y-MM-DD").toDate()
      : null,
    query?.registered_to ? moment(query?.registered_to || "", "Y-MM-DD").toDate() : null,
  ]);
  const [registered_from, registered_to] = dateSearch;

  const [linkImage, setLinkImage] = useState<any>("");
  const [countrySearch, setCountrySearch] = useState<any>("kr");
  const [listCountry, setListCountry] = useState<any>([]);

  const selectLayoutState = (state: any) => state.User;
  const UserProperties = createSelector(selectLayoutState, (state) => ({
    users: state?.users,
    isUserLoading: state.isUserLoading,
    isUserSuccess: state.isUserSuccess,

    error: state.error,
  }));

  // Inside your component
  const { users, isUserLoading } = useSelector(UserProperties);

  useEffect(() => {
    dispatch(onGetUsers(query));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      nickname: nickNameSearch.trim() || "",
      profile_email: emailSearch.trim() || "",
      user_email: emailSNSSearch.trim() || "",
      ip: ipAddressSearch.trim() || "",
      app_version: appVersionSearch.trim() || "",
      device_model: deviceModelSearch.trim() || "",
      udid: uuid2Search.trim() || "",
      address: addressSearch.trim() || "",
      is_active: statusSearch,
      platform: platFormSearch?.value || "",
      os: oSSearch || "",
      country: countrySearch?.value || "",
      channel: channelSearch,
      login_type: userTypeSearch,
      type: accountTypeSearch,
      registered_from: registered_from ? formatISOString(registered_from, "start") : "",
      registered_to: registered_to ? formatISOString(registered_to, "end") : "",
      include_deleted: isDeletedUserSearch === 1 ? 1 : 0,
      //sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        nickname: "",
        profile_email: "",
        user_email: "",
        ip: "",
        app_version: "",
        device_model: "",
        udid: "",
        address: "",
        is_active: "",
        platform: "",
        os: "",
        country: "KR",
        channel: "",
        login_type: "",
        type: "",
        registered_from: "",
        registered_to: "",
        include_deleted: 0,
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setNicknameSearch((_prev) => "");
    setEmailSearch("");
    setEmailSNSSearch("");
    setIPAddressSearch((_prev) => "");
    setAppVersionSearch((_prev) => "");
    setDeviceModelSearch((_prev) => "");
    setUUID2Search((_prev) => "");
    setAddressSearch((_prev) => "");
    setStatusSearch("");
    setPlatFormSearch((_prev) => null);
    setOSSearch(null);
    setCountrySearch((_prev: any) => ({ value: "KR", label: "" }));
    setChannelSearch((_prev: any) => "");
    setUserTypeSearch("");
    setAccountTypeSearch("");
    setDateSearch([null, null]);
    setIsDeletedUserSearch(0);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    // onCloseClick();
    dispatch(onGetUsers(query));
  };
  //End::Update User

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {users?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("Status"),
        accessor: "is_active",
        thWidth: 80,
        filterable: false,
        sortable: false,
        thClass: "text-center",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return <CheckboxStatusUser item={item} />;
        },
      },
      {
        Header: t("Login Type"),
        accessor: "user_device.login_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value === "GUEST" ? "guest" : "normal";
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_USER_TYPE[status] || "secondary"
                }`}
              >
                {t(
                  LIST_OPTION_USER_TYPE?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
              )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Account Type"),
        accessor: "type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_USER_ACCOUNT_TYPE[status] || "secondary"
                }`}
              >
                {t(
                  LIST_OPTION_USER_ACCOUNT_TYPE?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
              )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Photo"),
        accessor: "photo",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.profile;

          return (
            <div className="w-100 text-center " style={{ minWidth: "80px" }}>
              <div
                style={{ width: "80px", borderRadius: "10px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage((prev: any) => item?.image_url)}
              >
                <img
                  src={item?.image_url ?? noUser}
                  style={{ borderRadius: "10px" }}
                  className="avatar-sm rounded-circle"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = noUser;
                  }}
                />
              </div>
            </div>
          )
        },
      },
      {
        Header: t("Nickname"),
        accessor: "profile.nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return cell?.value ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={cell?.value}>
              {`${cell?.value}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("Full Name"),
        accessor: "profile.fullname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return cell?.value ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={cell?.value}>
              {`${cell?.value}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("Email"),
        accessor: "profile.email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 220,
        Cell: (cell: any) => {
          const email = cell?.value;
          return email ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={email}>
              {`${email}`}
            </CopyWrapper>
          </div> : "-";
        },
      },
      {
        Header: t("Email SNS"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 220,
        Cell: (cell: any) => {
          const providerID = cell?.row?.original?.provider_id;
          const email = cell?.value ? cell?.value : providerID;

          return email ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={email}>
              {`${email}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("gender"),
        accessor: "profile.gender",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          return <div className="cursor-pointer">
            {t(
              LIST_OPTION_GENDER.find((i) => i.value == cell?.value)
                ?.label || "-"
            )}
          </div>;
        },
      },
      {
        Header: t("Platform"),
        accessor: "provider",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let user_provider = cell?.row?.original?.provider;
          let lowText = user_provider ? user_provider.toLowerCase() : '';
          let imgPlatform = getPlatFormImage(lowText);

          return user_provider ? (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="user_provider"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      lowText === "default" || lowText == "guest"
                        ? "Email"
                        : lowText
                    )
                  )}
                </div>
              </div>
            </div>
          ) : "-";
        },
      },

      {
        Header: t("OS"),
        accessor: "user_device.device.os",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.value;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS ? (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? ""
                  )}
                </div>
              </div>
            ) : '-'
          );
        },
      },
      {
        Header: t("Device Model"),
        accessor: "user_device.device.model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.user_device?.device;
          let deviceModel = item?.model;
          const os = item?.os;
          if(os === 'ios') {
            deviceModel = deviceModel ? (IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ?? deviceModel)  : '';
          }

          return deviceModel ? (
            <CopyWrapper contentCopy={t(`${deviceModel}`)} style={{ width: 150 }}>
              {t(`${deviceModel}`)}
            </CopyWrapper>
          ) : '-';
        },
      },
      {
        Header: t("Manufacturer"),
        accessor: "user_device.device.manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.value;
          return (
            manufacturer ? (
              <div className="cursor-pointer" style={{ minWidth: "160px" }}>
                <CopyWrapper contentCopy={manufacturer}>
                  {`${manufacturer}`}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },

      {
        Header: t("UUID"),
        accessor: "user_device.device.udid",
        filterable: true,
        sortable: false,
        thWidth: 220,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const udid = cell?.value;
          return udid ? (
            <div className="cursor-pointer" style={{ minWidth: "200px" }}>
              <CopyWrapper contentCopy={udid}>
                {`${udid}`}
              </CopyWrapper>
            </div>
          ) : '-';
        },
      },
      {
        Header: t("App Version"),
        accessor: "user_device",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const row = cell?.value;
          const appVersion = row?.app_build
            ? `${row?.app_version} (${row?.app_build})`
            : row?.app_version;
          return appVersion ? (
            <div className="cursor-pointer" style={{ minWidth: "110px" }}>
              <CopyWrapper contentCopy={appVersion}>
                {`${appVersion}`}
              </CopyWrapper>
            </div>
          ) : '-';
        },
      },
      {
        Header: t("IP"),
        accessor: "user_device.ip_address",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const ip = cell?.value;
          return ip ? (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
            </div>
          ) : '-';
        },
      },
      {
        Header: t("FCM Token"),
        accessor: "user_device.device.fcm_token",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 360,
        Cell: (cell: any) => {
          const token = cell?.value;

          return (
            token ? (
              <div className="cursor-pointer" style={{ maxWidth: "330px" }}>
                <CopyWrapper contentCopy={token} style={{ minWidth: "70px", whiteSpace: "nowrap" }}>
                  {truncate(token, 40)}
                </CopyWrapper>
              </div>
            ) : '-'
          );
        },
      },
      {
        Header: t("Address"),
        accessor: "address.address",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const address = cell?.value;
          return address ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={address}>{address}</CopyWrapper>
          </div> : '-'
        },
      },
      {
        Header: t("Country"),
        accessor: "user_device.ip_address_country_code",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 150,
        Cell: (cell: any) => {
          const countryCode = cell?.value;
          const country = countries.find((item) => item?.code === countryCode);

          return (
            countryCode && (
              <div
                className="d-flex flex-column gap-1"
                style={{ minWidth: "120px" }}
              >
                {
                  <div className="cursor-pointer d-flex gap-2 align-items-center ">
                    {country && (
                      <>
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                        <div className="cursor-pointer">
                          {i18n?.language === "ko"
                            ? country?.name_korea
                            : country?.name}
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
            )
          );
        },
      },
      {
        Header: t("Channel"),
        accessor: "install_source",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          let channel = cell?.value;
          let imgChannel = getPlatFormImage(channel);

          return (
            <div
              className="d-flex flex-column gap-1"
              style={{ minWidth: "100px" }}
            >
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgChannel && (
                    <img
                      src={imgChannel}
                      width={25}
                      height={25}
                      alt="channel"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    LIST_CHANNEL_USER_OPTION?.find(
                      (item: any) => String(item?.value) === String(channel)
                    )?.label || ""
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Sign-up Date"),
        accessor: "registered_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return cell?.value ? (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          ) : <div className="text-end">-</div>
        },
      },
      {
        Header: t("Action"),
        thClass: "text-center",
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0">
              <TooltipCustom
                title={t("Detail User")}
                id={`detail-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </TooltipCustom>

              <TooltipCustom
                title={t("Button Delete Operator")}
                id={`detail-cp-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e: any) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, users?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  // Begin::Delete
  const handleActionDelete = async (id: any) => {
    if (!id) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await deleteUser(id);
      if (response?.statusCode) {
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setItemToDelete(false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Delete

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          userApi.getCountries({ page: 1, limit: 1000 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
        if (query?.country) {
          const _country = resCountry?.data?.find(
            (_c: any) => String(_c?.code) === String(query?.country)
          );
          setCountrySearch((_prev: any) =>
            _country ? { value: _country?.code, label: _country?.name } : null
          );
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  const onCloseImageClick = () => {
    setLinkImage("");
  };

  useEffect(() => {
    if (userPermissions === "COMPANY" && !isHavePermissionRole([ROLES_FOR_APP.USER_MANAGEMENT], userPermissions)) {
      navigate(ROUTES.APPLICATION_MANAGEMENT, { replace: true });
    }
  }, [userPermissions, navigate]);

  useEffect(() => {
    document.title = `${t("User Management")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("User Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={users?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Nickname")}`}
                          isShow={!!nickNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={nickNameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Email")} isShow={!!emailSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Email SNS")} isShow={!!emailSNSSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email SNS")}...`}
                            value={emailSNSSearch}
                            onChange={(e) => setEmailSNSSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Ip Address")}
                          isShow={!!ipAddressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Ip Address")}...`}
                            value={ipAddressSearch}
                            onChange={(e) => setIPAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("App Version")}`}
                          isShow={!!appVersionSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("App Version")}...`}
                            value={appVersionSearch}
                            onChange={(e) => setAppVersionSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Device Model")}`}
                          isShow={!!deviceModelSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Model")}...`}
                            value={deviceModelSearch}
                            onChange={(e) =>
                              setDeviceModelSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("UUID")}`}
                          isShow={!!uuid2Search}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuid2Search}
                            onChange={(e) => setUUID2Search(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Address")}`}
                          isShow={!!addressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Address")}...`}
                            value={addressSearch}
                            onChange={(e) => setAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_USER_OPTION_LANG || []}
                            placeholder={`${t("Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_POST}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="platform"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="country"
                            dataList={listCountry || []}
                            placeholder={""}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || null}
                            onChangeSelect={(e: any) => setCountrySearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            // isDefaultKorea={true}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Channel")} isShow={true}>
                          <DropdownChannelUser
                            name="channel"
                            placeholder={`${t("Channel")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={channelSearch}
                            onChangeSelect={(e: any) => {
                              setChannelSearch(e?.value);
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Account Type")} isShow={true}>
                          <DropdownStatusNew
                            name="account-type"
                            dataList={LIST_OPTION_USER_ACCOUNT_TYPE || []}
                            placeholder={`${t("Account Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={accountTypeSearch}
                            onChangeSelect={(e: any) =>
                              setAccountTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_ACCOUNT_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Login Type")} isShow={true}>
                          <DropdownStatusNew
                            name="user-type"
                            dataList={LIST_OPTION_USER_TYPE || []}
                            placeholder={`${t("Login Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={userTypeSearch}
                            onChangeSelect={(e: any) =>
                              setUserTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!registered_from || !!registered_to}
                        >
                          <DatePickerCustom
                            startDate={registered_from || null}
                            endDate={registered_to || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Deleted User")} isShow={true}>
                          <div
                            className="form-check form-switch form-switch-sm text-center"
                            dir="ltr"
                            style={{
                              width: 80,
                              paddingTop: 10,
                              paddingLeft: 10,
                            }}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              name="is_active"
                              checked={isDeletedUserSearch === 1}
                              style={{ marginLeft: 0 }}
                              onChange={(e) => {
                                const value = e?.target?.checked;
                                setIsDeletedUserSearch(value === true ? 1 : 0);
                              }}
                            />
                          </div>
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={9}
                        lg={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-user-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={users?.items?.length ? users?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={users?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(users?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isUserLoading}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ToastContainer closeButton={false} limit={1} />
        {
          itemToEdit && (
            <UserDetail
              isOpen={!!itemToEdit}
              item={itemToEdit}
              onClose={onCloseClick}
              triggerRefresh={triggerRefresh}
            />
          )
        }

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {itemToDelete && (
          <ModalConfirm
            header={t("Button Delete User")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default UserManagement;
